import { useState } from "react";
import { faqItems } from "@/mocks/homeSections";

export default function FaqSection() {
  const [openId, setOpenId] = useState<string | null>(faqItems[0].id);

  return (
    <section id="faq" className="w-full border-t border-background-200 bg-background-50 py-16 md:py-20">
      <div className="mx-auto w-full max-w-[1240px] px-4 md:px-6">
        <div className="grid grid-cols-1 gap-10 lg:grid-cols-[0.8fr_1.6fr] lg:gap-14">
          <div>
            <h2 className="text-2xl font-bold tracking-tight text-foreground-950 md:text-3xl">
              常见问题
            </h2>
            <p className="mt-3 text-sm leading-relaxed text-foreground-700 md:text-base">
              关于暗网流出物料的整理方式、来源标注与更新节奏，这里先说清楚。
            </p>
          </div>

          <div className="divide-y divide-background-200 border-y border-background-200">
            {faqItems.map((item) => {
              const isOpen = openId === item.id;
              return (
                <div key={item.id}>
                  <button
                    type="button"
                    onClick={() => setOpenId(isOpen ? null : item.id)}
                    className="flex w-full items-center justify-between gap-4 py-5 text-left cursor-pointer"
                  >
                    <span className="text-sm font-medium text-foreground-950 md:text-base">
                      {item.q}
                    </span>
                    <span
                      className={`flex h-7 w-7 flex-none items-center justify-center rounded-full transition-colors ${
                        isOpen
                          ? "bg-primary-500 text-background-50"
                          : "bg-background-100 text-foreground-600"
                      }`}
                    >
                      <i className={isOpen ? "ri-subtract-line" : "ri-add-line"}></i>
                    </span>
                  </button>
                  {isOpen && (
                    <p className="pb-5 pr-10 text-sm leading-relaxed text-foreground-600">
                      {item.a}
                    </p>
                  )}
                </div>
              );
            })}
          </div>
        </div>
      </div>
    </section>
  );
}